var exports = {
  "kL": "x93eb46d8--159ea0--container",
  "iE": "x93eb46d8--159ea0--wrapper",
  "DD": "x93eb46d8--159ea0--title",
};

module.exports = exports;
